<div class="table-responsive table-hover table-block">
  <table class="table bg-white" *ngIf="!loading">
    <thead class="bg-header-table">
      <tr>
        <th i18n class="text-left">Permissões</th>
        <th i18n class="text-left">Usuários</th>
        <th i18n class="text-right">Ações</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let permission of adminPermissionsPaginated">
        <td (click)="openDetail(permission)">
          <p class="mb-0" i18n>{{ permissionI18n[permission.name] }}</p>
        </td>
        <td class="user-list-control"
          (click)="openDetail(permission)">
          <div
            *ngFor="let user of permission.users">
            <div
              class="user-list-control__item"
              title="{{user.name || user.email}}">
              <app-avatar
                [user]="{ name: user.name, avatar: null }"
                class="avatar-header mb-0">
              </app-avatar>
              <button
                class="mr-2 mt-0"
                title="Remover usuário {{user.name}}"
                (click)="openDeleteModalUser(user, permission)">
                <i class="material-icons">close</i>
              </button>
            </div>
          </div>
        </td>
        <td class="text-right">
          <button
            type="button"
            class="btn text-secondary btn-icon-block"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false">
            <i class="material-icons">more_horiz</i>
          </button>
          <div
            class="dropdown-menu"
            aria-labelledby="btnGroupDrop4">
            <a
              class="dropdown-item"
              (click)="addUsers(permission.id)" i18n>
              Adicionar Usuários
            </a>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
  <div class="loading-page" *ngIf="loading">
    <div class="loading-spinner">
      <div class="bounce1"></div>
      <div class="bounce2"></div>
      <div class="bounce3"></div>
    </div>
  </div>
</div>
<div class="row mt-2" *ngIf="!loading">
  <div class="col-md-12">
    <app-pagination-simple
      (items)="setAdminPermissionsPaginated($event)"
      [data]="adminPermissions">
    </app-pagination-simple>
  </div>
</div>
